import React from 'react';
import { Link } from 'react-router-dom';
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';

const Grievance = () => {
    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">Grievance Redressal</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/employee-dashboard">
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Grievance Redressal
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                        <div className="head-icons ms-2">
                            <CollapseHeader />
                        </div>
                    </div>
                </div>
                {/* /Breadcrumb */}
                <div className="card">
                    <div className="card-body p-3">
                        <div>
                            <h3>Redressal of Grievance</h3>
                            <p>
                                In case of any grievance, the insured person may contact the company through:
                            </p>
                            <ul>
                                <p>
                                    <strong>Website:</strong>{' '}
                                    <a href="https://www.icicilombard.com" target="_blank" rel="noopener noreferrer">
                                        www.icicilombard.com
                                    </a>
                                </p>
                                <p>
                                    <strong>Toll Free:</strong>{' '}
                                    <a href="tel:18002666" style={{ color: 'orange' }}>
                                        1800 2666
                                    </a>
                                </p>
                                <p>
                                    <strong>E-Mail:</strong>{' '}
                                    <a href="mailto:customersupport@icicilombard.com" style={{ color: 'orange' }}>
                                        customersupport@icicilombard.com
                                    </a>
                                </p>
                                <p>
                                    <strong>Courier:</strong> ICICI Lombard General Insurance Company Limited.
                                    <br />
                                    ICICI Lombard House, 414, Veer Savarkar Marg, Near Siddhi Vinayak Temple, Prabhadevi, Mumbai- 400025
                                </p>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
                <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>

            </div>
        </div>
    );
};

export default Grievance;
